import useWindowSize from "../hooks/useWindowSize";
import "../styles/components/AssignmentSuccessModal.css";

/* ═══════════════════════ ASSIGNMENT SUCCESS MODAL ═══════════════════════ */
export default function AssignmentSuccessModal({
  isOpen,
  onClose,
  caregiverName,
  residentName,
  assignmentType,
  shiftType,
}) {
  const { isMobile } = useWindowSize();

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        className="assignment-success-backdrop"
      />

      {/* Modal */}
      <div className={`assignment-success-modal ${isMobile ? "mobile" : ""}`}>
        {/* Success Icon */}
        <div className={`assignment-success-modal__icon ${isMobile ? "mobile" : ""}`}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6ADD00"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        {/* Title */}
        <h2 className={`assignment-success-modal__title ${isMobile ? "mobile" : ""}`}>
          Assignment Successful!
        </h2>

        {/* Message */}
        <p className={`assignment-success-modal__message ${isMobile ? "mobile" : ""}`}>
          <strong>{caregiverName}</strong> has been successfully assigned to{" "}
          <strong>{residentName}</strong> as a <strong>{assignmentType}</strong> caregiver
          for the <strong>{shiftType}</strong> shift.
        </p>

        {/* OK Button */}
        <button
          onClick={onClose}
          className={`assignment-success-modal__button ${isMobile ? "mobile" : ""}`}
        >
          OK
        </button>
      </div>
    </>
  );
}
